import { useCallback, useMemo, useState } from "react";
import { Form, Modal } from "antd";
import { useTranslation } from "react-i18next";

import { Cancel, SearchWidget } from "components/UI";
import { useDebounceValue } from "hooks";
import DetailSelectedTable from "components/UI/ListSuggestionForm/DetailSelectedTable";

const DetailSelectedModal = ({
  visible,
  name,
  data,
  disabled,
  title,
  titleColumn,
  onCancel,
}) => {
  const { t } = useTranslation();
  const form = Form.useFormInstance();
  const [params, setParams] = useState({
    search: "",
  });
  const debouncedSearch = useDebounceValue(params?.search, 1000);

  const formattedData = useMemo(() => {
    if (!data) {
      return [];
    }
    const newData = (data || [])
      .map((item, index) => {
        const escapedSearch = (debouncedSearch || "")?.replace(/\\/g, "\\\\");
        const reg = new RegExp(escapedSearch, "gi");
        const match = (item?.label || "")?.match(reg);
        if (!match) {
          return null;
        }
        return {
          ...item,
          key: index,
        };
      })
      .filter((record) => !!record);
    return newData;
  }, [data, debouncedSearch]);

  const filterHandler = useCallback(
    (values) => setParams((prev) => ({ ...prev, ...values })),
    []
  );

  const deleteHandler = useCallback(
    (row) => {
      const filteredData = data?.filter((item) => item?.value !== row?.value);
      form?.setFieldValue(name, filteredData);

      if (filteredData?.length === 0) {
        onCancel();
      }
    },
    [form, name, data, onCancel]
  );

  const closeHandler = useCallback(() => {
    filterHandler({ search: "" });
    onCancel();
  }, [onCancel, filterHandler]);

  return (
    <Modal
      open={visible}
      title={`${title ? `${title} ` : ""}`}
      onCancel={closeHandler}
      footer={
        <div className="flex flex-row gap-2 justify-end">
          <Cancel onClick={closeHandler} title={t("button.close")} />
        </div>
      }
      destroyOnClose
    >
      <div className="flex flex-row justify-end mb-5">
        <SearchWidget
          value={params.search}
          onChange={(e) => filterHandler({ search: e?.target?.value })}
        />
      </div>
      <DetailSelectedTable
        data={formattedData}
        titleColumn={titleColumn}
        disabled={disabled}
        onDelete={deleteHandler}
      />
    </Modal>
  );
};

export default DetailSelectedModal;
